import { render, staticRenderFns } from "./AccountManage.vue?vue&type=template&id=933f8fcc&scoped=true"
import script from "./AccountManage.vue?vue&type=script&lang=js"
export * from "./AccountManage.vue?vue&type=script&lang=js"
import style0 from "./AccountManage.vue?vue&type=style&index=0&id=933f8fcc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "933f8fcc",
  null
  
)

export default component.exports